export const LIST_GAME = 'LIST_GAME'
export const LIST_GAME_INFINITE = 'LIST_GAME_INFINITE'
export const LIST_LEADER_BOARD = 'LIST_LEADER_BOARD'
export const DETAIL_GAME = 'DETAIL_GAME'
export const TOTAL_GAME = 'TOTAL_GAME'
export const LIST_HISTORY_WHEEL_GAME_USER = 'LIST_HISTORY_WHEEL_GAME_USER'
export const LIST_WHEEL_GAME = 'LIST_WHEEL_GAME'
export const DETAIL_WHEEL_GAME = 'DETAIL_WHEEL_GAME'
export const TOTAL_WHEEL_GAME_BY_GAME = 'TOTAL_WHEEL_GAME_BY_GAME'
